export class WhatsAppInfra {
  static async sendMessage(params: {
    phoneNumber: string;
    message: string;
  }) {
    const phone = params.phoneNumber.replace(/[^0-9]/g, '');
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(params.message)}`;
    window.open(url);
  }
}